import { ComponentProps, FC } from 'react';

import { SvgIcon } from './SvgIcon';

export const Drop: FC<ComponentProps<typeof SvgIcon>> = props => (
  <SvgIcon width="20" height="20" viewBox="0 0 16 20" {...props}>
    <path d="M8 17.58C6.4 17.58 4.89 16.96 3.76 15.83C2.62 14.69 2 13.19 2 11.58C2 10 2.62 8.47002 3.76 7.34002L8 3.10002M13.66 5.93002L8 0.27002L2.34 5.93002C-0.78 9.05002 -0.78 14.12 2.34 17.24C3.9 18.8 5.95 19.58 8 19.58C10.05 19.58 12.1 18.8 13.66 17.24C16.78 14.12 16.78 9.05002 13.66 5.93002Z" />
  </SvgIcon>
);
